import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModifyColumnDisplayModalComponent } from '@app/views/claims/modify-column-display-modal/modify-column-display-modal.component';
import { RefineResultsModalComponent } from '@app/views/claims/refine-results-modal/refine-results-modal.component';
import { SelectedCriteriaComponent } from '@app/views/claims/selected-criteria/selected-criteria.component';
import {
    AccordionModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    CustomModalModule,
    DatepickerModule,
    GridModule,
    HigTooltipModule,
    HiguxModalModule,
    InfoFieldsModule,
    InputModule,
    ModalScrollService,
    PaginatorModule,
    RadioModule,
    SelectModule,
    TabsModule,
    TextareaModule,
    TypeaheadSelectModule,
    TypographyModule
} from 'hig-ng-lib';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HierarchyOfLocationsTreeComponent } from '@app/views/claims/hierarchy-of-locations-tree/hierarchy-of-locations-tree.component';
import { BooleanTypeComponent } from '@app/views/claims/dynamic-form-components/boolean-type/boolean-type.component';
import { CurrencyTypeComponent } from '@app/views/claims/dynamic-form-components/currency-type/currency-type.component';
import { DateTypeComponent } from '@app/views/claims/dynamic-form-components/date-type/date-type.component';
import { NumberTypeComponent } from '@app/views/claims/dynamic-form-components/number-type/number-type.component';
import { StringTypeComponent } from '@app/views/claims/dynamic-form-components/string-type/string-type.component';
import { ListTypeComponent } from '@app/views/claims/dynamic-form-components/list-type/list-type.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    ModifyColumnDisplayModalComponent,
    RefineResultsModalComponent,
    SelectedCriteriaComponent,
    HierarchyOfLocationsTreeComponent,
    BooleanTypeComponent,
    CurrencyTypeComponent,
    DateTypeComponent,
    NumberTypeComponent,
    StringTypeComponent,
    ListTypeComponent,
],
imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    AccordionModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    CustomModalModule,
    DatepickerModule,
    GridModule,
    HigTooltipModule,
    HiguxModalModule,
    InfoFieldsModule,
    InputModule,
    PaginatorModule,
    RadioModule,
    TabsModule,
    TextareaModule,
    TypeaheadSelectModule,
    TypographyModule
],
providers: [ModalScrollService],
schemas: [CUSTOM_ELEMENTS_SCHEMA],
exports: [
    ModifyColumnDisplayModalComponent,
    RefineResultsModalComponent,
    SelectedCriteriaComponent,
    HierarchyOfLocationsTreeComponent,
    BooleanTypeComponent,
    CurrencyTypeComponent,
    DateTypeComponent,
    NumberTypeComponent,
    StringTypeComponent,
    ListTypeComponent
]
})
export class SharedViewsComponentModule { }
